<template>
    <div>
        <h3>制限値</h3>
        <div>
            <p>
                貸し本棚には複数の制限値が設定されており、制限値を超えるとエラーが発生します。
            </p>
            <h4>公開された制限値</h4>
            <p>
                １エピソード（１話）に記述できる文字数は10万字となっています（１作品ではありません）。
                ノートの場合は保存されたデータ長が64KBに制限されます。
                ピックアップに表示できるのは３作品までで、それ以上の作品は追加できません。
            </p>
            <p>
                これらの公開制限値は貸し本棚全体の制限値であり、
                すべてのユーザに適用されます。
            </p>
            <h4>非公開制限値</h4>
            <p>
                公式には「追加できるエピソード数に制限はありません」としていますが、
                これは理論値の制限であり、実際にはシステム上の制約があります。
                追加できる作品数にも制限があります。
            </p>
            <p>
                この制限値はユーザー単位で設定され、お試しユーザーは少なく設定されます。
                また、制限値が近くなったとき、管理者が任意に、あるいは自動的に制限値を拡張することがあります。
            </p>
            <p>
                これらの制限値は、特定のユーザーが大量投稿によってリソースを圧迫させる問題、
                また大量のエピソード数投入によってエピソード一覧の表示に不具合が生じる問題を防ぐための閾値です。
                制限に到達した場合、管理者へ制限の拡張を依頼してください。
            </p>
            <h5>非公開制限</h5>
            <p>
                全作品を非公開にしている場合、制限値の拡張は行われません。
            </p>
            <h4>大量投稿対策</h4>
            <p>
                同時期に作品を大量投稿し、ポータルを独占した場合、
                <b>ごく稀に</b>不正検知によって加重エイジング、シャドウバン、あるいは強制退会処理が実行されることがあります（滅多にありません）。
            </p>
            <p>
                この機能はAI作品の大量投稿への対策ですが、多作の作家様にも適用されることがあります。
                100を超える作品を一度に投稿される場合は、一度管理者へご相談ください。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "制限値 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>